import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { CellEditingStoppedEvent, ColDef, GridApi, IServerSideDatasource, IServerSideGetRowsParams } from 'ag-grid-community';
import { ObjectUnsubscribedError, Observable, catchError, filter, map, of } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { WarehouseAreaDetailsComponent } from '../warehouse-area-details/warehouse-area-details.component';

@Component({
  selector: 'app-warehouse-row-details',
  templateUrl: './warehouse-row-details.component.html',
  styleUrls: ['./warehouse-row-details.component.scss']
})
export class WarehouseRowDetailsComponent implements ICellRendererAngularComp {

  public gridReady = true;
  public themeClass: string = "ag-theme-ulaap";

  public detailCellRenderer: any = WarehouseAreaDetailsComponent

  bays: any[] = [
    { id: 1, total_positions: 156, filled_positions: 35, empty_positions: 121 },
    { id: 2, total_positions: 200, filled_positions: 126, empty_positions: 74 },
    { id: 3, total_positions: 180, filled_positions: 100, empty_positions: 80 },
    { id: 4, total_positions: 220, filled_positions: 150, empty_positions: 70 },
    { id: 5, total_positions: 190, filled_positions: 120, empty_positions: 70 }
  ]

  ngOnInit(): void {
  }

  agInit(params: any) {
  }

  private gridApi!: GridApi;

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  defaultColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
    },
    autoHeight: true,
    cellClass: 'cell-wrap-text',
    resizable: true,
    editable: true,
  };

  public columnDefs: ColDef[] = [
    { field: 'id', headerName: 'Bay No.', cellRenderer: 'agGroupCellRenderer' },
    { field: 'total_positions', headerName: 'Total Positions' },
    { field: 'filled_positions', headerName: 'Filled Positions' },
    { field: 'empty_positions', headerName: 'Empty Positions' },
    // { field: 'highest_row', headerName: 'Highest Row'},
    // { field: 'highest_section', headerName: 'Highest Section'},
    // { field: 'highest_spot', headerName: 'Highest Spot'},
    // { field: 'total', headerName: 'Total'},
    // { field: 'occupied', headerName: 'Occupied' },
  ]

  refresh(params: any): boolean {
    return false;
  }

}
